import { useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import Icon, { IconType } from 'components/Icon';
import DropdownMenu from 'components/Widget/DropdownMenu';
import { MenuItemAction } from 'menu/MenuItem';
import { setActiveDsMode } from 'redux/mode/actions';
import { selectModeResolution } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';
import { DS_EDITOR_PREVIEW_BG_DEFAULT } from 'tokens';
import * as S from './styles';

const DsModeDropdown = () => {
	const dispatch = useDispatch();

	const { modes, activeModeId, defaultModeId } = useSelector(
		(r: RootReducer) => selectModeResolution(r.mode),
		shallowEqual
	);

	//----------------------------------------------------------------------
	// HANDLERS
	//----------------------------------------------------------------------
	const onSelect = (id: string) => {
		dispatch(setActiveDsMode(id === defaultModeId ? null : id));
	};

	//----------------------------------------------------------------------
	// RENDERING
	//----------------------------------------------------------------------
	const menuItems = useMemo(() => {
		if (!modes) return [];
		return modes.map(
			(m) => new MenuItemAction(m.label, '', () => onSelect(m.id), false, m.id === activeModeId)
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modes, activeModeId]);

	if (!modes || modes.length < 2) return null;

	const activeMode = modes.find((m) => m.id === activeModeId) ?? modes[0];
	const swatchColor = activeMode.bg ?? DS_EDITOR_PREVIEW_BG_DEFAULT;

	return (
		<DropdownMenu menuItems={menuItems}>
			<S.Base>
				<S.Swatch $color={swatchColor} />
				{activeMode.label}
				<Icon type={IconType.FILLED_ARROW_DOWN} width={12} height={12} />
			</S.Base>
		</DropdownMenu>
	);
};

export default DsModeDropdown;
